import { CoreApplicationContext } from '@eventbrite/context-gen';
import { setLanguage } from '@eventbrite/i18n';
import React from 'react';
import { default as Routes } from './pages/routes';

export default class DiscoverApp extends React.Component {
    constructor(props: CoreApplicationContext) {
        super(props);

        setLanguage(props.env.localeInfo.locale);
    }

    render() {
        return <Routes {...this.props} />;
    }
}
